import { render, staticRenderFns } from "./UserProfilePoints.vue?vue&type=template&id=34ef4e30&scoped=true&"
import script from "./UserProfilePoints.vue?vue&type=script&lang=js&"
export * from "./UserProfilePoints.vue?vue&type=script&lang=js&"
import style0 from "./UserProfilePoints.vue?vue&type=style&index=0&id=34ef4e30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ef4e30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VContainer,VDivider,VProgressCircular,VProgressLinear,VTab,VTabItem,VTabs,VTabsItems})
